<template>
  <div class="background-image">
    <div style="width: 1200px; margin: 0 auto 0; padding: 200px 0 0 0">
      <el-container>
        <el-aside width="160px">
          <el-menu
            default-active="Login"
            class="el-menu-vertical-demo"
            @select="menuSelect"
            @open="handleOpen"
            @close="handleClose"
            text-color="#fff"
            router="true"
          >
            <el-menu-item index="Login"> 登录注册</el-menu-item>
            <el-menu-item index="Person"> 个人中心 </el-menu-item>
            <el-menu-item index="2"> 权限管理 </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main>
          <!-- <div
            style="
              width: 300px;
              margin: 0 0 0 10%;
              background: #fff;
              border-radius: 5px;
              padding: 30px 50px 30px 0;
            "
          >
            <el-form
              label-width="100px"
              :model="formLabelAlign"
              style="max-width: 380px"
            >
              <el-form-item>
                <el-input v-model="formLabelAlign.name" />
              </el-form-item>
              <el-form-item>
                <el-input v-model="formLabelAlign.region" />
              </el-form-item>
              <el-form-item>
                <el-input v-model="formLabelAlign.type" />
              </el-form-item>
            </el-form>
          </div> -->
          <!-- <div class="form-row">
            <el-form
              label-width="100px"
              :model="formLabelAlign"
              style="max-width: 460px"
            >
              <el-form-item label="邮箱/手机号">
                <el-input v-model="formLabelAlign.name" />
              </el-form-item>
              <el-form-item label="密码">
                <el-input v-model="formLabelAlign.name" />
              </el-form-item>
              <el-form-item label="验证码">
                <el-input v-model="formLabelAlign.name">
                  <template #append>
                    <el-button type="primary">获取验证码</el-button>
                  </template>
                </el-input>
              </el-form-item>

              <el-form-item style="margin-left: 0; float: right">
                <el-button type="primary">Submit</el-button>
              </el-form-item>
            </el-form>
          </div> -->
          <router-view></router-view>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
// import type { FormProps } from "element-plus";
const formLabelAlign = reactive({
  name: "",
  region: "",
  type: "",
});

const handleOpen = (key, keyPath) => {
  console.log(key, keyPath);
};
const handleClose = (key, keyPath) => {
  console.log(key, keyPath);
};
const menuSelect = (index) => {
  console.log(index, "++++");
};
</script>

<style scoped>
.form-row {
  width: 400px;
  margin: 0 0 0 20%;
  background: #fff;
  border-radius: 10px;
  padding: 30px 20px 60px;
}
.el-menu {
  height: 300px;
  background: rgba(0, 0, 0, 0.2);
  border: none;
}
.el-menu-item.is-active {
  color: #fff;
  background: #cd0104;
}
/deep/.el-menu--vertical:not(.el-menu--collapse):not(.el-menu--popup-container)
  .el-menu-item,
.el-menu--vertical:not(.el-menu--collapse):not(.el-menu--popup-container)
  .el-menu-item-group__title,
.el-menu--vertical:not(.el-menu--collapse):not(.el-menu--popup-container)
  .el-sub-menu__title {
  white-space: nowrap;
  padding: 10px 0;
  padding-left: 45px;
}
.text-center {
  overflow-y: hidden;
}

.carousel-item {
  color: #475669;
  opacity: 0.75;
  margin: 0;
  text-align: center;
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  display: flex;
  align-items: center;
  margin: 0;
  text-align: center;
  height: 100%;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.container {
  width: 1200px;
  margin: 80px auto 0;
  color: #fff;
  div {
    width: 100%;
  }
  h1 {
    font-size: 40px;
    line-height: 0px;
  }
  span {
    font-size: 16px;
  }
  .line {
    width: 80%;
    height: 1px;
    background: #8d0100;
    margin: 10px auto 30px;
  }
}
</style>
